import type { FC } from "react";

import { getSessionStorage } from "@jti/rest-api";
import { useSelector } from "@jti/store/reduxHooks";

import { PaymentSummary } from "@checkout/components/PaymentSummary";
import { SummaryLoyaltyPoints } from "@checkout/components/SummaryLoyaltyPoints";
import { useLoyaltyStatus } from "@checkout/hooks/useLoyaltyStatus";
import { useOrder } from "@checkout/hooks/useOrder";
import { usePrice } from "@checkout/hooks/usePrice";

const sessionStorage = getSessionStorage();

export const OrderPaymentSummary: FC = () => {
  const { order, orderFetchStatus } = useOrder();
  const { prices } = usePrice(order, false);
  const isLoyaltyActive = useLoyaltyStatus();

  const { loyaltyChoice } = useSelector((store) => store.loyalty);

  const points = sessionStorage.get("loyaltyCartPoints", 0);

  return (
    <PaymentSummary isPricesLoading={orderFetchStatus === "pending"} prices={prices}>
      {isLoyaltyActive ? (
        <SummaryLoyaltyPoints
          hasLoyalty={isLoyaltyActive}
          totalLoyaltyPoints={points}
          loyaltyChoice={loyaltyChoice || 0}
        />
      ) : null}
    </PaymentSummary>
  );
};
